import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { App as CapApp } from '@capacitor/app';
import { Toast } from '@capacitor/toast';
import Home from './components/Home';
import AdminPanelWrapper from './components/AdminPanelWrapper';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const backPressTime = React.useRef(0);

  React.useEffect(() => {
    let handlerOrPromise = CapApp.addListener('backButton', async () => {
      console.log('Android back button pressed! Path:', location.pathname);
      if (location.pathname !== '/') {
        navigate(-1);
      } else {
        const now = Date.now();
        if (now - backPressTime.current < 2000) {
          CapApp.exitApp();
        } else {
          backPressTime.current = now;
          await Toast.show({ text: 'Press back again to exit' });
        }
      }
    });
    return () => {
      // CapApp.addListener returns a Promise in web, so handle both Promise and direct object
      Promise.resolve(handlerOrPromise).then(handler => {
        if (handler && typeof handler.remove === 'function') {
          handler.remove();
        }
      });
    };
  }, [location, navigate]);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/admin-panal/*" element={<AdminPanelWrapper />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
